import { ReactNode } from "react";

export function renderHighlight(entry: any, field: string): null | ReactNode[] {
  const highlight = entry._highlights?.find(
    (h: any) => h.path === `fields.${field}` || h.path === field,
  );

  if (!highlight) {
    return null;
  }

  return highlight.texts.map(
    (t: { value: string; type: "hit" | "text" }, i: number) =>
      t.type === "hit" ? (
        <u key={i}>{t.value}</u>
      ) : (
        <span key={i}>{t.value}</span>
      ),
  );
}
